import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0628b852"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "advanced-properties"
}

import { ref, watch } from 'vue'
import type { ConfigProperty } from './config'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormBuilder',
  props: {
    configProperties: {},
    hasErrors: { type: Boolean }
  },
  emits: ['update:hasErrors'],
  setup(__props: any, { emit }) {

const props = __props;





const standardProperties = ref<ConfigProperty[]>(props.configProperties.filter(p => !isAdvancedProperty(p)))
const advancedProperties = ref<ConfigProperty[]>(props.configProperties.filter(p => isAdvancedProperty(p)))

const showAdvancedProperties = ref<boolean>(false)

watch(
  props.configProperties,
  (properties) => {
    properties.some(p => p.error === true && p.id !== 'packageName')
      ? emit('update:hasErrors', true)
      : emit('update:hasErrors', false)
  },
)

function checkForJsonError(configProp: ConfigProperty) {
  if (configProp.value != null && configProp.value !== '') {
    try {
      JSON.parse(configProp.value)
      configProp.error = false
    } catch (e) {
      configProp.error = true
    }
  } else {
    configProp.value = null
    configProp.error = false
  }
}

function isAdvancedProperty(property: ConfigProperty) {
  return property.advanced ?? false
}

return (_ctx: any,_cache: any) => {
  const _component_DodoIcon = _resolveComponent("DodoIcon")!
  const _component_DodoButton = _resolveComponent("DodoButton")!
  const _component_PrimeColumn = _resolveComponent("PrimeColumn")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_PlayStoreFinder = _resolveComponent("PlayStoreFinder")!
  const _component_DodoRow = _resolveComponent("DodoRow")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_PrimeTextarea = _resolveComponent("PrimeTextarea")!
  const _component_PrimeDropdown = _resolveComponent("PrimeDropdown")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_PrimeCheckbox = _resolveComponent("PrimeCheckbox")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([standardProperties.value, advancedProperties.value], (properties, index) => {
    return (_openBlock(), _createElementBlock("div", { key: index }, [
      (properties === advancedProperties.value && properties.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_DodoButton, {
              rounded: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showAdvancedProperties.value = !showAdvancedProperties.value))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DodoIcon, {
                  name: showAdvancedProperties.value ? 'expand_less' : 'expand_more'
                }, null, 8, ["name"]),
                _createTextVNode(" Advanced properties ")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_DataTable, {
        value: properties,
        hidden: properties === advancedProperties.value && !showAdvancedProperties.value,
        "table-style": "width: 100%"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_PrimeColumn, {
            field: "property",
            header: "Property",
            style: {"width":"40%"}
          }, {
            body: _withCtx(({ data: { property } }) => [
              _createElementVNode("div", null, _toDisplayString(property), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_PrimeColumn, {
            field: "value",
            header: "Value",
            style: {"width":"60%"}
          }, {
            body: _withCtx(({ data }) => [
              (data.type == 'packageName')
                ? (_openBlock(), _createBlock(_component_DodoRow, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputText, {
                        modelValue: data.value,
                        "onUpdate:modelValue": ($event: any) => ((data.value) = $event),
                        placeholder: "Search package, or insert",
                        class: _normalizeClass({ 'p-invalid': data.error ?? false })
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                      _createVNode(_component_PlayStoreFinder, {
                        packageName: data.value,
                        "onUpdate:packageName": ($event: any) => ((data.value) = $event)
                      }, null, 8, ["packageName", "onUpdate:packageName"])
                    ]),
                    _: 2
                  }, 1024))
                : (data.type == 'string')
                  ? (_openBlock(), _createBlock(_component_InputText, {
                      key: 1,
                      modelValue: data.value,
                      "onUpdate:modelValue": ($event: any) => ((data.value) = $event),
                      placeholder: "Insert text",
                      class: _normalizeClass({ 'p-invalid': data.error ?? false })
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]))
                  : (data.type == 'integer')
                    ? (_openBlock(), _createBlock(_component_InputNumber, {
                        key: 2,
                        modelValue: data.value,
                        "onUpdate:modelValue": ($event: any) => ((data.value) = $event),
                        placeholder: "0"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                    : (data.type == 'json')
                      ? (_openBlock(), _createBlock(_component_PrimeTextarea, {
                          key: 3,
                          modelValue: data.value,
                          "onUpdate:modelValue": ($event: any) => ((data.value) = $event),
                          placeholder: "Insert json",
                          rows: "7",
                          class: _normalizeClass({ 'p-invalid': data.error ?? false }),
                          onInput: ($event: any) => (checkForJsonError(data))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "onInput"]))
                      : (data.type == 'dropdown')
                        ? (_openBlock(), _createBlock(_component_PrimeDropdown, {
                            key: 4,
                            modelValue: data.value,
                            "onUpdate:modelValue": ($event: any) => ((data.value) = $event),
                            options: data.options,
                            placeholder: "Select an option",
                            "show-clear": ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                        : (data.type == 'multiselect')
                          ? (_openBlock(), _createBlock(_component_MultiSelect, {
                              key: 5,
                              modelValue: data.value,
                              "onUpdate:modelValue": ($event: any) => ((data.value) = $event),
                              options: data.options,
                              placeholder: "Select one or more options",
                              "max-selected-labels": 1
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                          : (data.type == 'boolean')
                            ? (_openBlock(), _createBlock(_component_PrimeCheckbox, {
                                key: 6,
                                modelValue: data.value,
                                "onUpdate:modelValue": ($event: any) => ((data.value) = $event),
                                binary: true
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                _createTextVNode(" template not found ")
                              ], 64))
            ]),
            _: 1
          })
        ]),
        _: 2
      }, 1032, ["value", "hidden"])
    ]))
  }), 128))
}
}

})